export default __webpack_public_path__ + "static/media/Christina_Korp_AHV_In_Moms_We_Trust.15608f63.jpg";